{
  "(optional)": "(facultatif)",
  "(required)": "(requis)"
}
